<template>
  <div class="schedule" v-if="showEvent">
    <schedule-event
      @refush='refush'
      :info="editEventInfo"
      :driverInfo="loadDialogInfo"
      :showEvent="showEvent"
      @close="closeEventDialog"
      v-if="showEvent"></schedule-event>
  </div>
</template>
<script>
import scheduleEvent from './components/schedule-event.vue'
import { mapGetters, mapActions } from 'vuex'
import { getService$ } from '@/shared-services.js'
export default {
  components: { scheduleEvent },
  beforeRouteLeave(to, from, next) {
    this.setShowEvent(false)
    next();
  },
  name: 'Schedule',
  data() {
    return {
      // dialogVisible: false,
    }
  },
  mounted() {
    console.log('schedule create')
  },
  computed: {
     ...mapGetters('schedule', [
      'scheduleList',
      'editEventInfo',
      'loadDialogInfo',
      'showEvent'
    ]),
    ...mapGetters("user", ["usersAuthorities", "systemSource"]),
  },
  methods: {
    ...mapActions('schedule', [
      'setLoadDialogInfo',
      'setShowEvent',
      'seteditEventInfo'
    ]),
    closeEventDialog() {
      this.setShowEvent(false)
    },
    refush() {
      getService$('CommandTools').subscribe(x => {
        x.$reloadScheduleDriverList.next({reload: true})
      })
    },
  }
}
</script>
<style scoped lang="scss">
.schedule{
  height: 1px;
  width: 100%;
  overflow: hidden;
  background: #f0f2f5;

  /deep/ {
    .tp-right-header{
      padding-top: 24px !important;
    }
    .schedule-table {
      height: calc(100% - 64px);
    }
  }
}
.schedule-filter{
  /* margin-top: 10px; */
  height: 78px;
}
</style>
